// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-dashboard-state-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.delete-dashboard-state-container{
    position: absolute;
    border-radius: 5px;
    padding: 8px 24px;
    background-color: white;
    font-family: Roboto, sans-serif;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.delete-dashboard-state-container h4{
    font-size: 20px;
    font-weight: 500;
    margin: 20px 0px;
    color: rgba(0, 0, 0, 0.87);
}
.delete-dashboard-state-container p{
    font-size: 16px;
    font-weight: 400;
    margin: 10px 0px;
    color: rgba(0, 0, 0, 0.6);
}
.delete-dashboard-state-buttons-container{
    text-align: right;
    padding: 12px 0px;
}
.delete-dashboard-state-buttons-container button{
    border: none;
    margin-left: 12px;
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    font-family: Roboto, sans-serif;
    background-color: transparent;
    color: rgba(155, 30, 30, 0.952);
}
.delete-dashboard-state-buttons-container button:hover{
    background-color: rgb(240, 240, 240);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Dashboards/DeleteDashboardState.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,4DAA4D;AAChE;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,+BAA+B;IAC/B,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;AACnC;AACA;IACI,oCAAoC;AACxC","sourcesContent":[".delete-dashboard-state-parent-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.delete-dashboard-state-container{\r\n    position: absolute;\r\n    border-radius: 5px;\r\n    padding: 8px 24px;\r\n    background-color: white;\r\n    font-family: Roboto, sans-serif;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.delete-dashboard-state-container h4{\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    margin: 20px 0px;\r\n    color: rgba(0, 0, 0, 0.87);\r\n}\r\n.delete-dashboard-state-container p{\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    margin: 10px 0px;\r\n    color: rgba(0, 0, 0, 0.6);\r\n}\r\n.delete-dashboard-state-buttons-container{\r\n    text-align: right;\r\n    padding: 12px 0px;\r\n}\r\n.delete-dashboard-state-buttons-container button{\r\n    border: none;\r\n    margin-left: 12px;\r\n    padding: 10px 24px;\r\n    border-radius: 4px;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    font-family: Roboto, sans-serif;\r\n    background-color: transparent;\r\n    color: rgba(155, 30, 30, 0.952);\r\n}\r\n.delete-dashboard-state-buttons-container button:hover{\r\n    background-color: rgb(240, 240, 240);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
